module.exports = __webpack_public_path__ + "img/10-1-bg.55e03ea4.png";